import { DynamicObjectInterface } from '../../sdk/type';
import { SearchValue } from '../components';

type DynamicValue = string | number | Date | Date[] | object | { value: string };

export const filterData = (tableData: DynamicObjectInterface[], criteria: SearchValue): DynamicObjectInterface[] => {
  const filteredResult = tableData.filter((item: DynamicObjectInterface) => filterItem(item, criteria));
  return filteredResult;
};

const filterItem = (item: DynamicObjectInterface, criteria: SearchValue): boolean => {
  for (const key in criteria) {
    if (!Object.prototype.hasOwnProperty.call(item, key)) {
      return false;
    }

    if (conditionFilter(key, criteria[key], item)) {
      return false;
    }
  }
  return true;
};

const conditionFilter = (key: string, criteriaValue: DynamicValue, item: DynamicObjectInterface): boolean => {
  if (!(key in item)) {
    return false;
  }
  const itemValue = item[key];
  if (typeof criteriaValue === 'object' && 'value' in criteriaValue) {
    return itemValue?.toString()?.toLocaleLowerCase() !== criteriaValue.value.toLocaleLowerCase();
  }

  if (
    (typeof itemValue === 'string' || typeof itemValue === 'number') &&
    (typeof criteriaValue === 'string' || typeof criteriaValue === 'number')
  ) {
    const criteriaString = criteriaValue.toString();
    const itemString = itemValue.toString();
    return !itemString.toLowerCase().includes(criteriaString.toLowerCase());
  }

  if (criteriaValue instanceof Date) {
    let date = new Date(itemValue);
    return !(
      date.getFullYear() === criteriaValue.getFullYear() &&
      date.getMonth() === criteriaValue.getMonth() &&
      date.getDate() === criteriaValue.getDate()
    );
  }

  return itemValue !== criteriaValue;
};
